export function ShieldTick({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0042 2.33545C10.2572 2.33546 10.474 2.37146 10.6038 2.41846V2.41943L15.1829 4.1333V4.13428C15.4513 4.2365 15.7362 4.46622 15.9554 4.78467C16.1472 5.06339 16.256 5.36318 16.2786 5.62549L16.2835 5.73486V12.4917C16.2835 12.6815 16.2157 12.9555 16.0735 13.2397C15.9323 13.5222 15.7543 13.7415 15.6009 13.8579L11.0179 17.2827L11.0159 17.2837C10.7643 17.4731 10.3967 17.5894 9.99542 17.5894C9.64454 17.5893 9.31971 17.5011 9.0755 17.3521L8.97589 17.2837L8.97394 17.2827L4.39093 13.8579L4.38702 13.855L4.27081 13.7534C4.15147 13.633 4.02503 13.4578 3.91827 13.2437C3.7761 12.9585 3.70831 12.6821 3.70831 12.4917V5.7417C3.70831 5.45298 3.82231 5.10536 4.04327 4.78662C4.26418 4.46798 4.5511 4.23807 4.82355 4.13525L4.82257 4.13428L9.4046 2.41943L9.40363 2.41846C9.53336 2.37132 9.75074 2.33545 10.0042 2.33545ZM13.3343 6.58447C12.8316 6.17517 12.1016 6.17515 11.5989 6.58447L11.4944 6.67822L8.88312 9.28857L8.51398 8.91943L8.40948 8.82568C7.90695 8.41656 7.17673 8.41667 6.67413 8.82568L6.56964 8.91943C6.03621 9.45286 6.03553 10.325 6.56671 10.8599V10.8608L7.89972 12.2104L7.90265 12.2134C8.17572 12.4864 8.5288 12.6167 8.87531 12.6167C9.17834 12.6166 9.48553 12.5167 9.74054 12.3091L9.84698 12.2134L13.43 8.63037L13.429 8.62939C13.9394 8.1271 13.9697 7.321 13.5325 6.78271L13.4388 6.67822L13.3343 6.58447Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
